/**
 * useOnReturnToApp — appelle `onReturn` quand l'élève revient dans l'app : elle repasse au premier
 * plan après avoir été quittée.
 *
 * Une seule source, `AppState` : sur mobile, l'app qui repasse `active` après `background` ou
 * `inactive` ; sur le web, react-native-web dérive `AppState` de `visibilitychange` (l'onglet caché
 * puis revu — l'élève qui revient de sa boîte mail dans un autre onglet). Ni au montage, ni quand
 * l'app reste devant : seulement au retour.
 *
 * Le crochet des ports (le legacy a `common/hooks/useOnAppForeground`, que les ports n'importent pas).
 */
import { useEffect, useRef } from "react"
import { AppState, type AppStateStatus } from "react-native"

export function useOnReturnToApp(onReturn: () => void): void {
    // Le rappel du dernier rendu : l'abonnement n'est posé qu'une fois.
    const onReturnRef = useRef(onReturn)
    onReturnRef.current = onReturn

    useEffect(() => {
        let previous: AppStateStatus = AppState.currentState
        const subscription = AppState.addEventListener("change", (next) => {
            const cameBack = next === "active" && previous !== "active"
            previous = next
            if (cameBack) onReturnRef.current()
        })
        return () => subscription.remove()
    }, [])
}
